import { getHolidays } from "feiertagejs";
import { moment } from "../date";
import type { Tables } from "../types/database.types";
import { getEmploymentYears } from "./get-employment-years";

export function getEmploymentHolidays(employment: Tables<"employments">) {
	const years = getEmploymentYears(employment);
	let holidays: string[] = [];

	for (const year of years) {
		const yearHolidays = getHolidays(year, employment.region);
		const yearHolidaysDb = yearHolidays.map((holiday) => moment(holiday.date).db());
		holidays.push(...yearHolidaysDb);
	}

	holidays = holidays.filter((date) => {
		return moment(date).isBetween(
			employment.validFrom,
			employment.validTo || moment().endOf("year"),
			"dates",
			"[]",
		);
	});

	return holidays;
}
